import { create } from "zustand"

const useStoreSnackbar = create(
    (set, get) => ({
        snackbarData:{
            open: false,
            message: "",
            severity: "success"
        },
        setSnackbarData: (data) => {
            set(() => ({
                snackbarData: data
            }))
        },
    })
)

export default useStoreSnackbar